import BreadcrumbSection from "../components/single-team/breadcrumb-section";
import SingleTeamSection from "../components/single-team/single-team-section";
import TeamInfoSection from "../components/single-team/team-info-section";

export default function SingleTeam() {
	return (
		<>
			<BreadcrumbSection />
			<SingleTeamSection />
			<TeamInfoSection />
		</>
	);
}
